import React from 'react';
import MainLayout from '../components/layout/MainLayout';
import LiteratureTable from '../components/literature/LiteratureTable';
import TrendingUpdates from '../components/literature/TrendingUpdates';
import FilterBar from '../components/literature/FilterBar';
import ArticleDetails from '../components/literature/ArticleDetails';

const LiteratureSentinel = () => {
  return (
    <MainLayout 
      activeNavItem="literature"
      searchPlaceholder="Search: Literature"
      notifications={3}
    >
      <div className="flex h-full">
        <div className="flex-1 p-6 overflow-auto">
          <h2 className="text-2xl font-bold mb-4">Literature Sentinel</h2>
          <FilterBar />
          <LiteratureTable />
          <TrendingUpdates />
        </div>
        <div className="w-80">
          <ArticleDetails />
        </div>
      </div>
      <div className="bg-gray-200 text-gray-600 text-sm p-2 border-t border-gray-300">
        Personalized for: Dr. [Name] | Based on your patient population & interests
      </div>
    </MainLayout>
  );
};

export default LiteratureSentinel;